import { NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { UploadObj } from 'src/app/classes/upload-obj.class';
import { getFileContentType } from 'src/app/lib/get-file-type';
import { UploadService } from 'src/app/services/upload.service';
import { CircleProgressBarComponent } from '../../../shared/components/circle-progress-bar/circle-progress-bar.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { DataUnitsPipe } from '../../../shared/pipes/data-units.pipe';

@Component({
  selector: 'app-upload-item',
  templateUrl: './upload-item.component.html',
  styleUrls: ['./upload-item.component.scss'],
  standalone: true,
  imports: [NgIf, SvgComponent, TooltipDirective, CircleProgressBarComponent, DataUnitsPipe],
})
export class UploadItemComponent implements OnInit, OnChanges {
  @Input() upload: UploadObj;
  @Input() gallery: GalleryDto;
  @Input() preventDismiss = false;
  @Input() generatePreview = false;
  @Output() onDismissError: EventEmitter<UploadObj> = new EventEmitter();
  @ViewChild('item') item: ElementRef;
  previewSrc: string;
  previewMode: 'asset' | 'gallery' | 'unknown' | 'custom';
  maxPreviewSize = 10; // megabytes

  constructor(private uploadService: UploadService) {}

  async ngOnInit() {
    this.previewMode = this.getPreviewMode();
    if (this.generatePreview) {
      this.previewSrc = await this.getPreviewSrc();
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.generatePreview?.currentValue) {
      this.previewSrc = await this.getPreviewSrc();
    }
  }

  private async getPreviewSrc() {
    if (this.upload.imageSrc) return this.upload.imageSrc;
    // if (this.previewMode !== 'custom') return;
    // await sleep(0);
    // // const b64 = await fileToBase64(this.upload.file);
    // // try {
    // //   const img = await loadImg(b64);
    // //   return imageResize(img, 128, 0.8);
    // // } catch {}
    // this.previewMode = 'unknown';
  }

  private getPreviewMode() {
    // if (this.upload.imageSrc) return 'custom';
    const contentType = getFileContentType(this.upload.file);
    const fileType = contentType.split('/')[1]?.toLowerCase();
    if (fileType === 'gallery') return 'gallery';
    if (!this.uploadService.allowedFileType(this.upload.file, this.gallery)) return 'unknown';
    if (this.upload.file.size > 1024 * 1024 * this.maxPreviewSize) return 'asset';
    if (!['jpg', 'jpeg', 'png'].includes(fileType)) return 'asset';
    return 'asset';
    // return 'custom';
  }

  dismissError() {
    this.onDismissError.emit(this.upload);
  }
}
